import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Cleave from 'cleave.js/react';
import 'cleave.js/dist/addons/cleave-phone.us';

import { Overlay } from './../UIComponents';
import RadioButton from './../FormComponents/RadioButtonItem';

import utils from './../../lib/utils';

import './Modal.scss';

const PhonePrefix = '+1';

const onContentClick = (event) => {
  event.preventDefault();
  event.stopPropagation();
};

const contentProps = {
  onClick: onContentClick,
};

export default class CallForwardingSetupModal extends React.Component {
  constructor() {
    super();

    this.state = {
      selectedPhoneNumber: -1,
      isPhoneNumberValid: false,
      countdown: 0,
    };

    this.newPhoneForm = null;
    this.onVerifyClick = this.onVerifyClick.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
    this.renderPhoneListItem = this.renderPhoneListItem.bind(this);
    this.onNewNumberRadioChange = this.onNewNumberRadioChange.bind(this);
    this.onPhoneChange = this.onPhoneChange.bind(this);
    this.startCountdown = this.startCountdown.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!Object.keys(nextProps.business.phoneList).length) {
      this.setState({
        selectedPhoneNumber: -1,
      });
    }
  }

  onVerifyClick() {
    let phone;
    if (this.state.selectedPhoneNumber === -1) {
      phone = `${PhonePrefix}${this.state.phone}`;
    } else {
      phone = this.state.selectedPhoneNumber;
    }

    this.props.addPhoneNumber({
      phoneNumber: phone,
    });

    // Start countdown timer
    this.startCountdown();
  }

  onCancelClick() {
    this.props.abortTextCallForwardVerify();

    this.props.onCancel();
  }

  onNewNumberRadioChange() {
    this.setState({
      selectedPhoneNumber: -1,
    });
  }

  onPhoneChange(event) {
    const phone = event.target.rawValue;

    if (phone.length === 10) {
      this.setState({
        phone,
        isPhoneNumberValid: true,
      });
    } else {
      this.setState({
        phone,
        isPhoneNumberValid: false,
      });
    }
  }

  startCountdown() {
    let timer;

    this.setState(
      {
        countdown: 120,
      },
      () => {
        timer = setInterval(() => {
          if (this.state.countdown === 0) {
            return clearInterval(timer);
          }

          this.setState({
            countdown: this.state.countdown - 1,
          });

          return true;
        }, 1000);
      },
    );
  }

  renderPhoneListItem(item) {
    const onPhoneRemove = (event) => {
      event.preventDefault();

      this.props.removePhoneNumber({ phoneNumber: item.phoneNum });
    };

    const onPhoneItemRadioChange = (value) => {
      this.setState({
        selectedPhoneNumber: value,
      });
    };

    return (
      <div className="call-forwarding-modal__radio__row" key={item.phoneNum}>
        <RadioButton
          onChange={onPhoneItemRadioChange}
          item={{ value: item.phoneNum }}
          selected={this.state.selectedPhoneNumber === item.phoneNum}
        />
        <div className="radio-label">{utils.hyphenatePhone(item.phoneNum)}</div>
        <div className="radio-status">
          {item.status === 'VERIFIED' ? (
            <span className="message--success">Verified</span>
          ) : (
            <span className="message--error">Not Verified</span>
          )}
        </div>
        <a href="" onClick={onPhoneRemove} className="btn btn--link">
          Delete
        </a>
      </div>
    );
  }

  render() {
    const { onCancel } = this.props;
    const phoneList = Object.keys(this.props.business.phoneList).map((key) => {
      return this.props.business.phoneList[key];
    });

    let isVerifyEnabled = false;
    if (this.state.selectedPhoneNumber === -1) {
      isVerifyEnabled = this.state.isPhoneNumberValid;
    } else if (this.state.selectedPhoneNumber) {
      isVerifyEnabled = true;
    }

    const mins = Math.floor(this.state.countdown / 60);
    const secs = this.state.countdown % 60;
    const countdown = `${mins < 10 ? `0${mins}` : mins}:${
      secs < 10 ? `0${secs}` : secs
    }`;

    return (
      <div className={classnames('modal', { open: this.props.visibility })}>
        <Overlay onOverlayClick={onCancel}>
          <div className="call-forwarding-modal" {...contentProps}>
            <h4>Call forwarding setup</h4>
            <div className="call-forwarding-modal__radio">
              <div>
                {phoneList.map(this.renderPhoneListItem)}
                <div className="call-forwarding-modal__radio__row">
                  {phoneList.length ? (
                    <RadioButton
                      onChange={this.onNewNumberRadioChange}
                      selected={this.state.selectedPhoneNumber === -1}
                      item={{ value: '' }}
                    />
                  ) : (
                    undefined
                  )}
                  <div
                    className="form-group"
                  >
                    <h5>Enter a new business phone</h5>
                    <form
                      ref={(c) => {
                        this.newPhoneForm = c;
                      }}
                      className="business-phone"
                    >
                      <span className="business-phone__prefix">
                        {PhonePrefix}
                      </span>
                      <Cleave
                        placeholder="Enter phone number"
                        options={{ phone: true, phoneRegionCode: 'US' }}
                        onChange={this.onPhoneChange}
                      />
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="call-forwarding-modal__actions">
              <button
                className={classnames('btn', 'btn--primary', 'btn--lg', {
                  hide: this.props.carriers.isCallForwardVericationInProgress,
                })}
                onClick={this.onVerifyClick}
                disabled={
                  this.props.business.isPhoneAddInProgress || !isVerifyEnabled
                }
              >
                {this.props.business.isPhoneAddInProgress
                  ? `Verifying (${countdown})`
                  : 'VERIFY'}
              </button>
              <button
                className="btn btn--secondary btn--lg"
                onClick={this.onCancelClick}
              >
                Cancel
              </button>
            </div>
          </div>
        </Overlay>
      </div>
    );
  }
}

CallForwardingSetupModal.defaultProps = {
  visibility: false,
  addPhoneNumber: () => {},
  abortTextCallForwardVerify: () => {},
  onCancel: () => {},
  removePhoneNumber: () => {},
};

CallForwardingSetupModal.propTypes = {
  visibility: PropTypes.bool,
  addPhoneNumber: PropTypes.func,
  abortTextCallForwardVerify: PropTypes.func,
  onCancel: PropTypes.func,
  removePhoneNumber: PropTypes.func,
  carriers: PropTypes.shape({
    isCallForwardVericationInProgress: PropTypes.bool,
  }).isRequired,
  business: PropTypes.shape({
    phoneList: PropTypes.shape(),
    isPhoneAddInProgress: PropTypes.bool,
  }).isRequired,
};
